// Yotpo Global fix
var currentPathProductYotpo = window.location.pathname;

// Check if the path starts with "/products/"
if (currentPathProductYotpo.startsWith("/products/")) {
  setTimeout(() => {
    // Check if there are any elements with [class*="yotpo"]
    const yotpoElements = document.querySelectorAll('[class*="yotpo"]');

    if (yotpoElements.length > 0) {
      // SVG Elements
      // Dynamic aria-hidden="true" to all [class*="yotpo"] SVG elements
      const svgElements = document.querySelectorAll('[class*="yotpo"] SVG');

      svgElements.forEach((svg) => {
        svg.setAttribute("aria-hidden", "true");
      });
      // END OF - SVG Elements

      // Up and Down votes fix
      // Select all vote wrappers on the page
      const votesWrappers = document.querySelectorAll(
        ".yotpo-review-votes-icons-wrapper"
      );

      if (votesWrappers.length > 0) {
        votesWrappers.forEach((votesWrapper, index) => {
          // Add "Up Votes" to the first container
          const upVotesContainer = votesWrapper.querySelector(
            ".yotpo-review-votes-icons-container:first-child > .yotpo-review-votes-number"
          );
          if (upVotesContainer) {
            let upVotesSpan = upVotesContainer.querySelector("span.sr-only");
            if (!upVotesSpan) {
              upVotesSpan = document.createElement("span");
              upVotesSpan.classList.add("sr-only");
              upVotesContainer.appendChild(upVotesSpan);
            }
            upVotesSpan.textContent = "Up Votes";
          } else {
            console.warn(`No upVotesContainer found for wrapper ${index + 1}`);
          }

          // Add "Down Votes" to the last container
          const downVotesContainer = votesWrapper.querySelector(
            ".yotpo-review-votes-icons-container:last-child > .yotpo-review-votes-number"
          );
          if (downVotesContainer) {
            let downVotesSpan =
              downVotesContainer.querySelector("span.sr-only");
            if (!downVotesSpan) {
              downVotesSpan = document.createElement("span");
              downVotesSpan.classList.add("sr-only");
              downVotesContainer.appendChild(downVotesSpan);
            }
            downVotesSpan.textContent = "Down Votes";
          } else {
            console.warn(
              `No downVotesContainer found for wrapper ${index + 1}`
            );
          }

          // Initialize aria-pressed for all buttons within this wrapper
          const voteButtons = votesWrapper.querySelectorAll(
            '.yotpo-review-votes-icons[role="button"]'
          );
          voteButtons.forEach((button) => {
            button.setAttribute("aria-pressed", "false");
          });

          // Set aria-pressed to true for buttons with an initial vote count of 1
          const voteNumbers = votesWrapper.querySelectorAll(
            ".yotpo-review-votes-number"
          );
          voteNumbers.forEach((numberContainer, numberIndex) => {
            const rawVoteCount = numberContainer.textContent.trim();
            const voteCount = rawVoteCount.match(/\d+/)?.[0]; // Extract the numeric part
            const button = numberContainer
              .closest(".yotpo-review-votes-icons-container")
              ?.querySelector('.yotpo-review-votes-icons[role="button"]');
            if (button) {
              if (voteCount === "1") {
                button.setAttribute("aria-pressed", "true");
              } else {
                button.setAttribute("aria-pressed", "false");
              }
            } else {
              console.warn(
                `No button found for vote number in wrapper ${index + 1}`
              );
            }
          });

          // Observe changes in vote counts
          const observerVotes = new MutationObserver((mutationsList) => {
            mutationsList.forEach((mutation) => {
              if (mutation.type === "childList") {
                const rawVoteNumber = mutation.target.textContent.trim();
                const voteNumber = rawVoteNumber.match(/\d+/)?.[0]; // Extract numeric part
                const button = mutation.target
                  .closest(".yotpo-review-votes-icons-container")
                  ?.querySelector('.yotpo-review-votes-icons[role="button"]');
                if (button) {
                  if (voteNumber === "1") {
                    button.setAttribute("aria-pressed", "true");
                  } else if (voteNumber === "0") {
                    button.setAttribute("aria-pressed", "false");
                  }
                }
              }
            });
          });

          // Attach the observer to all vote numbers in this wrapper
          voteNumbers.forEach((number) => {
            observerVotes.observe(number, { childList: true, subtree: true });
          });
        });
      } else {
        console.error(
          "No elements with .yotpo-review-votes-icons-wrapper were found on the page. The Yotpo accessibility script failed. Contact the administrator."
        );
      }

      // END OF - Up and Down votes fix

      // Stars Filter - Radio group
      // Add role="group" to .yotpo-star-distribution and aria-labelledby
      const starDistribution = document.querySelector(
        ".yotpo-star-distribution"
      );
      if (starDistribution) {
        starDistribution.setAttribute("role", "group");

        // Create a new <p> element with the specified ID and class
        const labelParagraph = document.createElement("p");
        labelParagraph.id = "znt_452738523423826734523929876";
        labelParagraph.className = "znt-yotpo-group-label";
        labelParagraph.textContent = "Filter by:";

        // Insert the <p> element as the first child of .yotpo-star-distribution
        starDistribution.insertBefore(
          labelParagraph,
          starDistribution.firstChild
        );

        // Add aria-labelledby to .yotpo-star-distribution
        starDistribution.setAttribute("aria-labelledby", labelParagraph.id);

        // Add aria-pressed to each .yotpo-distribution-row
        const distributionRows = starDistribution.querySelectorAll(
          ".yotpo-distribution-row"
        );
        distributionRows.forEach((row) => {
          row.setAttribute("aria-pressed", "false");
        });

        // Observe changes in .yotpo-star-distribution
        const observer = new MutationObserver(() => {
          distributionRows.forEach((row) => {
            if (row.classList.contains("selected-row")) {
              row.setAttribute("aria-pressed", "true");
            } else {
              row.setAttribute("aria-pressed", "false");
            }
          });
        });

        observer.observe(starDistribution, {
          attributes: true,
          subtree: true,
          attributeFilter: ["class"],
        });
      } else {
        console.error(
          'The selector ".yotpo-star-distribution" was not found. The Yotpo accessibility script failed. Contact the administrator.'
        );
      }
      // END OF - Stars Filter - Radio group

      // Yotpo Dialog

      // Selectors Yotpo Dialog
      const SELECTORS = {
        mainWidget: ".yotpo-reviews-main-widget",
        mainWidgetLayout: ".yotpo-main-widget-layout",
        reviewForm: ".yotpo-review-form",
        inputValidation: ".yotpo-new-input-validation",
        inputWrapper: ".yotpo-input-wrapper",
        requiredInput: '[aria-required="true"]',
      };

      // Observer to monitor mutations in the DOM
      const observer = new MutationObserver((mutationsList) => {
        mutationsList.forEach((mutation) => {
          if (mutation.type === "childList") {
            // Check for added nodes
            mutation.addedNodes.forEach((node) => {
              if (
                node.nodeType === Node.ELEMENT_NODE &&
                node.classList.contains(
                  SELECTORS.mainWidget.replace(".", "")
                ) &&
                node.classList.contains(
                  SELECTORS.mainWidgetLayout.replace(".", "")
                )
              ) {
                handleWidgetAdded(node);
              }
            });

            // Check for removed nodes
            mutation.removedNodes.forEach((node) => {
              if (
                node.nodeType === Node.ELEMENT_NODE &&
                node.classList.contains(
                  SELECTORS.mainWidget.replace(".", "")
                ) &&
                node.classList.contains(
                  SELECTORS.mainWidgetLayout.replace(".", "")
                )
              ) {
                handleWidgetRemoved(node);
              }
            });
          }
        });
      });

      // Start observing the body
      observer.observe(document.body, { childList: true, subtree: true });

      function handleWidgetAdded(widget) {
        setTimeout(() => {
          // Form validation fixes
          // Checks all selectors
          // let allFound = true;

          // Object.values(SELECTORS).forEach(selector => {
          //     if (!document.querySelector(selector)) {
          //         console.error(`The selector [${selector}] was not found. The Yotpo accessibility script failed. Contact the administrator.`);
          //         allFound = false;
          //     }
          // });

          // if (allFound) {
          //     console.log('All selectors were found. The script is running properly.');
          // }

          // Close button fix
          const closeIcon = document.querySelector(
            ".yotpo-close-icon.btn-close"
          );

          if (closeIcon) {
            closeIcon.addEventListener("keydown", (event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault(); // Prevent default scrolling for spacebar
                closeIcon.click(); // Simulate click
              }
            });

            closeIcon.addEventListener("keyup", (event) => {
              if (event.key === " ") {
                event.preventDefault(); // Prevent default scrolling for spacebar
                closeIcon.click(); // Simulate click
              }
            });
          } else {
            console.error(
              "The .yotpo-close-icon.btn-close element was not found."
            );
          }

          // END OF - Close button fix

          // Find the form within the widget
          const yotpoReviewForm = widget.querySelector(SELECTORS.reviewForm);

          if (!yotpoReviewForm) {
            console.error(
              `The selector "${SELECTORS.reviewForm}" was not found within the widget. Contact the administrator, the Yotpo accessibility script failed.`
            );
            return;
          }

          // Set up a MutationObserver for the form
          const formObserver = new MutationObserver((formMutationsList) => {
            formMutationsList.forEach((mutation) => {
              if (mutation.type === "childList") {
                mutation.addedNodes.forEach((formNode) => {
                  if (formNode.nodeType === Node.ELEMENT_NODE) {
                    // Check for validation warning
                    const validationWarning = formNode.matches(
                      SELECTORS.inputValidation
                    )
                      ? formNode
                      : formNode.querySelector(SELECTORS.inputValidation);

                    if (validationWarning) {
                      const inputElement = validationWarning
                        ?.closest(SELECTORS.inputWrapper)
                        ?.querySelector(SELECTORS.requiredInput);

                      if (inputElement) {
                        if (!validationWarning.id) {
                          const uniqueId = `validation-${Math.random()
                            .toString(36)
                            .substr(2, 9)}`;
                          validationWarning.id = uniqueId;
                        }

                        if (!inputElement.hasAttribute("aria-describedby")) {
                          inputElement.setAttribute(
                            "aria-describedby",
                            validationWarning.id
                          );
                        }
                      }
                    }
                  }
                });
              }
            });
          });

          // Start observing the form for changes
          formObserver.observe(yotpoReviewForm, {
            childList: true,
            subtree: true,
          });
          // END OF - Form validation fixes

          // Dynamic adjusts
          // aria-hidden removal from asterist

          const starRatingLabel = document.querySelector(
            '[for="star-rating-input"]'
          );

          if (starRatingLabel) {
            const spanElement = starRatingLabel.querySelector("span");
            if (spanElement && spanElement.hasAttribute("aria-hidden")) {
              spanElement.removeAttribute("aria-hidden");
              console.log(
                'aria-hidden removed from [for="star-rating-input"] > span.'
              );
            } else {
              console.warn(
                'The span element inside [for="star-rating-input"] was not found or does not have aria-hidden.'
              );
            }
          } else {
            console.error(
              'The element [for="star-rating-input"] was not found. Cannot update aria-hidden.'
            );
          }

          // END OF - aria-hidden removal from asterist

          // Meaningful icon fix
          const targetElement = widget.querySelector(".yotpo-uploaded-images");

          if (targetElement) {
            const observerIconVideo = new MutationObserver((mutationsList) => {
              mutationsList.forEach((mutation) => {
                if (mutation.type === "childList") {
                  mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                      const videoIcon = node.matches("svg.yotpo-video-icon")
                        ? node
                        : node.querySelector("svg.yotpo-video-icon");

                      if (videoIcon) {
                        videoIcon.setAttribute("role", "image");
                        videoIcon.setAttribute("aria-label", "Video File Icon");
                      }
                    }
                  });
                }
              });
            });

            observerIconVideo.observe(targetElement, {
              childList: true,
              subtree: true,
            });
          } else {
            console.error(".yotpo-uploaded-images element was not found.");
          }

          // END OF - Meaningful icon fix

          // ariadescrribedby and ID to upload field
          const fileUploadElement =
            document.querySelector(".yotpo-file-upload");

          if (fileUploadElement) {
            const ariaDescribedByValue = "znt_726834435728234578";

            // Add `aria-describedby` to `.yotpo-upload-label .yotpo-images-input`
            const inputElement = fileUploadElement.querySelector(
              ".yotpo-upload-label .yotpo-images-input"
            );
            if (inputElement) {
              inputElement.setAttribute(
                "aria-describedby",
                ariaDescribedByValue
              );
            }

            // Add `id` to `.yotpo-new-input-message`
            const messageElement = fileUploadElement.querySelector(
              ".yotpo-new-input-message"
            );
            if (messageElement) {
              messageElement.setAttribute("id", ariaDescribedByValue);
            }
          } else {
            console.error(
              "The element .yotpo-file-upload was not found. Cannot update accessibility attributes."
            );
          }
          // END OF - ariadescrribedby and ID to upload field

          // END OF - Dynamic adjusts
        }, 2000); // Delay to ensure rendering
      }

      function handleWidgetRemoved(widget) {
        // Cleanup logic when the widget is removed
      }
      // END OF - Yotpo Dialog
    }
  }, 6000);
}
// END OF - Product page
